import { Configuration, UsersApi } from '@/api';
import CustomToast from '@/components/CustomToast';
import PageHeader from '@/components/PageHeader';
import { User } from '@/models/User';
import Breadcrumbs from '@/modules/admin/components/Breadcrumbs';
import UserForm from '@/modules/admin/components/UserForm';
import { UserListPath } from '@/modules/admin/paths';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const UserAdd = () => {
  const navigate = useNavigate();
  const auth = useAuth();

  const usersApi = new UsersApi(new Configuration(auth));

  const handleOnSubmit = async (user: User): Promise<void> => {
    try {
      await usersApi.createUser(user);

      toast.custom((t) => (
        <CustomToast
          id={t.id}
          message={`User "${user.username}" created successfully!`}
          visible={t.visible}
        />
      ));

      navigate(UserListPath);
    } catch (error) {
      console.error('Failed to create user:', error);
      toast.error('Failed to create user');
    }
  };

  return (
    <>
      <Breadcrumbs />

      <PageHeader title="Create User" />

      <div className="w-full bg-white mx-auto rounded-lg shadow p-6 lg:p-12">
        <UserForm onSubmit={handleOnSubmit} />
      </div>
    </>
  );
};

export default UserAdd;
